<template>
  <div>

      <div v-if="bundleConfigViewFlag" class="row">
        
        <div v-if="bundleConfigEditFlag" class="col-xs-12">

            <div v-if="actualBundleIsDefaultBundle==false" class="col-xs-12 col-sm-12">
              <div class="form-group">
                  <div class="col-sm-12">
                      <h4 class="font-w300 push">{{ textLabelBundleID[actualLanguage] }} : {{actualBundle.bundle_id.split("::").pop()}}</h4>
                      <h4 v-if="flagDisplayCompleteBundleName" class="font-w300 push">{{ textLabelBundleID[actualLanguage] }} : {{actualBundle.bundle_id}}</h4>
                  </div>
              </div>
            </div>



            <div class="col-xs-12">
              <div class="col-sm-12 col-md-6">
                <div>
                    <p><button @click="saveNewBundleName()" type="button" class="h3 btn btn-block btn-success align-left" name="button">
                      <spinner size="small" v-if="newBundleIsSaving"></spinner>
                      <span v-else>{{ buttonLabelModifySystemName[actualLanguage] }}</span></button></p>
                </div> 
              </div>

              <div class="col-sm-12 col-md-6">
                <div>
                    <p><button v-if="flagDisplayDeleteBundle" @click="deleteBundle()" type="button" class="h3 btn btn-block btn-danger align-left" name="button">
                      <spinner size="small" v-if="bundleIsDeleting"></spinner>
                      <span v-else><i class="fa fa-trash fa-1x push-5-r "></i>{{ buttonLabelDeleteSystem[actualLanguage] }}</span></button></p>
                </div> 
              </div>
            </div>
            

            <div  class="col-xs-12">
              <!-- Ce bouton n'est pas activé puisque la création de same leve lsystem considèere pas l'enregistrement dans un sous bundle !! -->
              <div v-if="false" class="col-sm-12 col-md-6">
                <div>
                    <p><button v-if="bundleConfigEditFlag" @click="createNewBundleInGroup()" type="button" class="h3 btn btn-block btn-success align-left" name="button">
                      <spinner size="small" v-if="addBundleIsSaving2"></spinner>
                      <span v-else><i class="fa fa-plus fa-1x push-5-r "></i><i class="fa fa-usb fa-1x push-5-r "></i>{{ buttonLabelCreateSameLevelSystem[actualLanguage] }}</span></button></p>
                </div> 
              </div>

              <div class="col-sm-12 col-md-6">
                <div>
                    <p><button v-if="bundleConfigEditFlag" @click="saveNewSubBundle()" type="button" class="h3 btn btn-block btn-success align-left" name="button">
                      <spinner size="small" v-if="addBundleIsSaving"></spinner>
                      <span v-else><i class="fa fa-plus fa-1x push-5-r "></i><i class="fa fa-usb fa-1x push-5-r "></i>{{ buttonLabelCreateSubSystem[actualLanguage] }}</span></button></p>
                </div> 
              </div>

            </div>
        </div>
      </div>


      <!-- Sharing section -->
      <div v-if="bundleSharingEnableFlag" class="block block-bordered">
        <div class="block block-themed">
          <div class="block-header bg-primary-dark">
                  <ul  class="block-options">

                      <li v-if="flagDisplaySharing===0">
                          <button type="button" @click="toggleDisplaySharing()"><i class="fa fa-angle-double-down fa-2x"></i></button>
                      </li>

                      <li v-if="flagDisplaySharing">
                          <button  type="button" @click="toggleDisplaySharing()"><i class="fa fa-angle-double-up fa-2x"></i></button>
                      </li>

                  </ul>
              <h2 class="h4 block-title" @click="toggleDisplaySharing()"><i class="fa fa-share-alt fa-1x push-5-r "></i>{{ blocTitleSharing[actualLanguage] }}</h2>
          </div>

          
          <div v-if="flagDisplaySharing" class="block-content">
            <div class="row">
                <div v-if="bundleConfigEditFlag" class="col-xs-12 push">
                  <button v-if="bundleSharingEnableFlag" @click="shareEntity()" type="button" class="btn btn-block btn-success align-left" name="button">
                    <i class="fa fa-share-alt fa-1x push-5-r "></i>{{ buttonLabelShareSystem[actualLanguage] }} : {{actualBundle.bundle_name}}</button>
                </div>

                <div class="col-xs-12 push">
                  <h6  class="font-w200">{{ textSharingDetail[actualLanguage] }}</h6>
                </div>

                <div class="col-xs-12 push">
                  <h4 class="push-5-r ">{{ blocTitleSharingList[actualLanguage] }}</h4>
                </div>
                
                <div class="col-xs-12">
                  <config-sharing-list  :sharingListData="{sharingType:'Bundle'}" ></config-sharing-list>
                </div>

            </div>
          </div>
        </div>
      </div>


      <!-- END Sharing section -->






      <!-- Attributes Sections -->
      <div class="block block-bordered">
        <div class="block block-themed">
          <div class="block-header bg-primary-dark">
                  <ul  class="block-options">

                      <li v-if="flagDisplayAttributes===0">
                          <button type="button" @click="toggleDisplayAttributes()"><i class="fa fa-angle-double-down fa-2x"></i></button>
                      </li>

                      <li v-if="flagDisplayAttributes">
                          <button  type="button" @click="toggleDisplayAttributes()"><i class="fa fa-angle-double-up fa-2x"></i></button>
                      </li>

                  </ul>
              <h2 class="h4 block-title" @click="toggleDisplayAttributes()"><i class="fa fa-tags fa-1x push-5-r "></i>{{blocLabelTags[actualLanguage] }}</h2>
          </div>

          <div v-if="flagDisplayAttributes" class="block-content">

            <div class="row">
              <div class="col-xs-12 items-push">
                <div class="col-xs-12">
                  <h6  class="font-w200">{{ textDescriptionTags[actualLanguage] }}</h6>
                </div>

                <div v-if="bundleConfigEditFlag" class="col-xs-12">
                  <button type="button" @click="addAttributeCategorie()" class="btn btn-xs align-right" name="buttonAddPlanItem"><i class="fa fa-plus fa-1x push-5-r "></i>{{ buttonLabelAddTagCategory[actualLanguage] }}</button>
                </div>
                <div class="col-xs-12">
                  <div v-for = "(categoryList ,index) in actualBundle.channelsAttributes">
                      <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
                          <div class="form-group">
                              <label class="col-xs-12" for="example-multiple-select">{{categoryList.title}}</label>
                                <div class="col-sm-12">
                                    <select class="form-control" v-model="channelAttributeSelect[index]" id="example-multiple-select" name="example-multiple-select" size="5">
                                        <option v-for= "(element, index2) in categoryList.data" :value="index2">{{element}}</option>
                                    </select>
                                </div>
                              <button v-if="bundleConfigEditFlag" type="button" @click="addAttributeElement(index)" class="btn btn-xs" name="buttonAddPlanItem"><i class="fa fa-plus fa-1x push-5-r "></i>{{ buttonLabelAddTag[actualLanguage] }}</button>
                              <button v-if="bundleConfigEditFlag" type="button" @click="deleteAttributeElement(index)" class="btn btn-xs" name="buttonAddPlanItem"><i class="fa fa-trash fa-1x push-5-r "></i>{{ buttonLabelDeleteTag[actualLanguage] }}</button>
                              <button v-if="bundleConfigEditFlag" type="button" @click="deleteCategoryList(index)" class="btn btn-xs" name="buttonAddPlanItem"><i class="fa fa-trash fa-1x push-5-r "></i>{{ buttonLabelDeleteTagCategory[actualLanguage] }}</button>
                          </div>
                      </div>
                  </div>
                </div>


                <div v-if="bundleConfigEditFlag" class="col-sm-12">
                  <label class="css-input switch switch-success">
                      <input @change="saveNewBundleConfiguration" type="checkbox" checked v-model="actualBundle.bundle_configuration.channelDisplayOptions.attributesDisplayFlag">
                      <span></span> {{ buttonLabelShowTags[actualLanguage] }}
                  </label>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <!-- END Static Labels -->








      <!-- Enable Pie Chart Sections -->
      <div class="block block-bordered">
        <div class="block block-themed">
          <div class="block-header bg-primary-dark">
                  <ul  class="block-options">

                      <li v-if="flagDisplayPieChart===0">
                          <button type="button" @click="toggleDisplayPieChart()"><i class="fa fa-angle-double-down fa-2x"></i></button>
                      </li>

                      <li v-if="flagDisplayPieChart">
                          <button  type="button" @click="toggleDisplayPieChart()"><i class="fa fa-angle-double-up fa-2x"></i></button>
                      </li>

                  </ul>
              <h2 class="h4 block-title" @click="toggleDisplayPieChart()"><i class="fa fa-pie-chart fa-1x push-5-r "></i>{{ blocLabelPieCharts[actualLanguage] }}</h2>
          </div>

          <div v-if="flagDisplayPieChart" class="block-content">

            <div class="row">
              <div class="col-xs-12 col-sm-12 push">
                <h6  class="font-w200">{{ textConfigPieChart[actualLanguage] }}</h6>
              </div>
              <div v-if="bundleConfigEditFlag" class="col-sm-12">
                <div class="col-xs-12 col-sm-12 push">
                  <label class="css-input switch switch-success">
                      <input @change="saveNewBundleConfiguration" type="checkbox" checked v-model="actualBundle.bundle_configuration.channelDisplayOptions.pieChartDisplayFlag">
                      <span></span> {{ buttonLabelDisplayPieChart[actualLanguage] }}
                  </label>
                </div>

                <div class="col-xs-12 col-sm-12 push">
                  <label class="css-input switch switch-success">
                      <input @change="saveNewBundleConfiguration" type="checkbox" checked v-model="actualBundle.bundle_configuration.channelDisplayOptions.displayChannelLocalizationFlag">
                      <span></span> {{ buttonLabelDisplayChannelLocalisation[actualLanguage] }}
                  </label>
                </div>


                
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END Enable Pie Chart Sections -->






      <!-- Channel Average Sections -->
      <div class="block block-bordered">
        <div class="block block-themed">
          <div class="block-header bg-primary-dark">
                  <ul  class="block-options">

                      <li v-if="flagDisplayChannelAverage===0">
                          <button type="button" @click="toggleDisplayChannelAverage()"><i class="fa fa-angle-double-down fa-2x"></i></button>
                      </li>

                      <li v-if="flagDisplayChannelAverage">
                          <button  type="button" @click="toggleDisplayChannelAverage()"><i class="fa fa-angle-double-up fa-2x"></i></button>
                      </li>

                  </ul>
              <h2 class="h4 block-title" @click="toggleDisplayChannelAverage()"></i><i class="fa fa-tasks fa-1x push-5-r "></i>{{ blocLabelMovingAverage[actualLanguage] }}</h2>
          </div>

          <div v-if="flagDisplayChannelAverage" class="block-content">

            <div v-if="bundleConfigEditFlag" class="row">
              <div class="col-xs-12 items-push">
                <div class="col-xs-12">
                  <h6  class="h3 font-w200">{{ textConfigMovingAverage[actualLanguage] }}</h6>
                </div>

                    <div class="col-sm-12">
                      <label class="h4 css-input switch switch-success">
                          <input @change="saveNewBundleConfiguration" type="checkbox" checked v-model="actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayEnable">
                          <span></span> {{ buttonLabelDisplayMA[actualLanguage] }}
                      </label>
                    </div>

                    <div  class="col-sm-12">
                      <label class="h4 css-input switch switch-success">
                          <input @change="saveNewBundleConfiguration" type="checkbox" checked v-model="actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayActual">
                          <span></span> {{ buttonLabelMA_DisplayActual[actualLanguage] }}
                      </label>
                    </div>

                    <div  class="col-sm-12">
                      <label class="h4 css-input switch switch-success">
                          <input @change="saveNewBundleConfiguration" type="checkbox" checked v-model="actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA001H">
                          <span></span> {{ buttonLabelMA_DisplayHr[actualLanguage] }} 1 hr
                      </label>
                    </div>

                    <div  class="col-sm-12">
                      <label class="h4 css-input switch switch-success">
                          <input @change="saveNewBundleConfiguration" type="checkbox" checked v-model="actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA004H">
                          <span></span> {{ buttonLabelMA_DisplayHr[actualLanguage] }} 4 hr
                      </label>
                    </div>

                    <div  class="col-sm-12">
                      <label class="h4 css-input switch switch-success">
                          <input @change="saveNewBundleConfiguration" type="checkbox" checked v-model="actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA006H">
                          <span></span> {{ buttonLabelMA_DisplayHr[actualLanguage] }} 6 hr
                      </label>
                    </div>            

                    <div  class="col-sm-12">
                      <label class="h4 css-input switch switch-success">
                          <input @change="saveNewBundleConfiguration" type="checkbox" checked v-model="actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA012H">
                          <span></span> {{ buttonLabelMA_DisplayHr[actualLanguage] }} 12 hr
                      </label>
                    </div>  

                    <div  class="col-sm-12">
                      <label class="h4 css-input switch switch-success">
                          <input @change="saveNewBundleConfiguration" type="checkbox" checked v-model="actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA024H">
                          <span></span> {{ buttonLabelMA_DisplayHr[actualLanguage] }} 1 {{ buttonLabelMA_Day[actualLanguage] }}
                      </label>
                    </div> 

                    <div  class="col-sm-12">
                      <label class="h4 css-input switch switch-success">
                          <input @change="saveNewBundleConfiguration" type="checkbox" checked v-model="actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA072H">
                          <span></span> {{ buttonLabelMA_DisplayHr[actualLanguage] }} 3 {{ buttonLabelMA_Days[actualLanguage] }}
                      </label>
                    </div>

                    <div  class="col-sm-12">
                      <label class="h4 css-input switch switch-success">
                          <input @change="saveNewBundleConfiguration" type="checkbox" checked v-model="actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA168H">
                          <span></span> {{ buttonLabelMA_DisplayHr[actualLanguage] }} 7 {{ buttonLabelMA_Days[actualLanguage] }}
                      </label>
                    </div>

                    <div  class="col-sm-12">
                      <label class="h4 css-input switch switch-success">
                          <input @change="saveNewBundleConfiguration" type="checkbox" checked v-model="actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA336H">
                          <span></span> {{ buttonLabelMA_DisplayHr[actualLanguage] }} 14 {{ buttonLabelMA_Days[actualLanguage] }}
                      </label>
                    </div>

                    <div  class="col-sm-12">
                      <label class="h4 css-input switch switch-success">
                          <input @change="saveNewBundleConfiguration" type="checkbox" checked v-model="actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA720H">
                          <span></span> {{ buttonLabelMA_DisplayHr[actualLanguage] }} 30 {{ buttonLabelMA_Days[actualLanguage] }}
                      </label>
                    </div>

              </div>
            </div>


          </div>
        </div>
      </div>
      <!-- END Channel Average -->









      <div v-if = "false" class="row">
        <div class="block">
        <div class="col-xs-12">
            <h4 >Description</h4>
            <div class="col-xs-6">
                <div class="form-group">
                    <label class="col-xs-12" for="example-select">Type</label>
                    <div class="col-sm-9">
                        <select class="form-control" id="example-select" name="example-select" size="1">
                            <option value="0">Sélectionner</option>
                            <option value="1">Résidentiel</option>
                            <option value="2">Commercial</option>
                            <option value="3">Industriel</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-xs-6">
                  <div class="form-group">
                    <label class="col-xs-12" for="example-select">Nombre d'occupant</label>
                    <div class="col-sm-9">
                        <select class="form-control" id="example-select" name="example-select" size="1">
                            <option value="0">Sélectionner</option>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-xs-6">
              <div class="form-group">
                  <label class="col-xs-12" for="example-multiple-select">Sélection Multiple</label>
                  <div class="col-sm-9">
                      <select class="form-control" id="example-multiple-select" name="example-multiple-select" size="5" multiple>
                          <option value="1">Option #1</option>
                          <option value="2">Option #2</option>
                          <option value="3">Option #3</option>
                          <option value="4">Option #4</option>
                          <option value="5">Option #5</option>
                          <option value="6">Option #6</option>
                          <option value="7">Option #7</option>
                          <option value="8">Option #8</option>
                          <option value="9">Option #9</option>
                          <option value="10">Option #10</option>
                      </select>
                  </div>
              </div>
            </div>
          </div>
          </div>
        </div>
        
      <div class="row">
        <hr></hr>
      </div>



            <!--
            <form class="form-horizontal push-10-t" action="base_forms_elements.html" method="post" onsubmit="return false;">

                <div class="form-group">
                  <div class="col-sm-6">
                    <label class="col-xs-12" for="lock1-password">Nom du Groupe Système</label>
                    <div class="col-xs-12">
                        <input v-model="tempoBundle.bundle_name" class="form-control" type="test" id="lock1-password" name="lock1-password" placeholder="Enter your password..">
                    </div>
                  </div>
                </div>

            </form>
            -->

    
  </div>

</template>

<script>

import _ from 'underscore'
import {mapState, mapGetters,mapActions} from 'vuex'
import Spinner from '@/components/Spinner'
import ConfigSharingList from './SubComponent/ConfigSharingList'

export default {
  //props: ['bundleIndex'],
  name: 'configureBundle',
  data() {
    return {
      displayDataTable : false,

      flagDisplaySubBundle : 0,
      flagDisplayPieChart : 0,
      flagDisplayAttributes : 0,
      flagDisplayChannelAverage : 0,
      flagDisplaySharing: 0,
      flagDisplayDeleteBundle : false,

      ListOfSharings:[],

      tempoBundle : {},
      newBundleIsSaving : false,
      addBundleIsSaving : false,
      addBundleIsSaving2 : false,
      bundleIsDeleting : false,
      channelAttributeSelect:[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],
      actualLanguage : "FR",
      labelTableTop: {FR: 'Afficher le tableau des données', EN: 'Display data table'},

      actualBundleIsDefaultBundle : true,
      flagDisplayCompleteBundleName : false,
      actualParentIsOwner : true,
      bundleConfigViewFlag : false,
      bundleConfigEditFlag : false,
      bundleConfigDeleteFlag : false,
      bundleSharingEnableFlag : false,

      textLabelBundleID: {FR: "Identifiant du système", EN: 'System ID'},
      buttonLabelModifySystemName : {FR: "Modifier le nom du Système", EN: 'Modify System name'},
      buttonLabelDeleteSystem : {FR: "Supprimer le Système sélectionné", EN: 'Delete selected System'},
      buttonLabelCreateSameLevelSystem : {FR: "Créer un Système de même niveau", EN: 'Create same level System'},
      buttonLabelCreateSubSystem : {FR: "Créer un Sous-Système", EN: 'Create Sub-System'},
      blocTitleSharing : {FR: "Partage du système", EN: 'System sharings'},
      blocTitleSharingList : {FR: "Liste des partage de Système", EN: 'System sharing list'},
      buttonLabelShareSystem : {FR: "Partager le système", EN: 'Share system'},
      textSharingDetail : {FR: "Le partage des composantes (module, appareils et VE) s'effectue en utilisant l'icône partage de chacun d'eux dans leur menu de configuration respectif. La liste des partages émits sont disponible pour visualisation ou modification de chacun des menus des composantes.", EN: 'Component sharing (module, device and VE) can be done by using the sharing icon on corresponding configuration menu. Sharing list is available for visualization or edition on top of corresponding component menu.'},
      blocLabelTags : {FR: "Étiquette de catégorisation des Appareils et Sous-Système", EN: 'Device and Sub-System categorisation tags'},
      textDescriptionTags : {FR: "Les étiquettes de permettent de filtrer les listes d'affichages. Créer des catégories et ensuite vous ajouter des étiquettes dans chacune de ces catégories.", EN: 'Tags allow to filter display list. You need to create you tags categories thenafter create tags in your defined categories.'},

      buttonLabelAddTagCategory: {FR: "Ajouter une catégorie d'étiquettes", EN: 'Add tags category'},
      buttonLabelAddTag: {FR: "Ajouter une étiquette", EN: 'Add tag'},
      buttonLabelDeleteTag: {FR: "Supprimer l'étiquette", EN: 'Delete selected tag'},
      buttonLabelDeleteTagCategory: {FR: "Supprimer la catégorie", EN: 'Delete category'},
      buttonLabelShowTags: {FR: "Afficher les étiquettes d'Appareils et Sous-Système dans l'onglet mesure", EN: 'Display Device and Sub-Systems tag in measurement menu'},
      blocLabelPieCharts: {FR: "Diagrammes circulaires et options d'affichage des appareils", EN: 'Pie charts and device display options'},
      textConfigPieChart: {FR: "Permet la comparaison des lectures des appareils (courant, Kwh et $).", EN: 'Allows to compare device consumption (peak current, Kwh and $).'},
      buttonLabelDisplayPieChart: {FR: "Afficher les diagrammes circulaires (pie charts)", EN: 'Display pie charts'},
      buttonLabelDisplayChannelLocalisation: {FR: "Afficher la carte de localisation par appareil", EN: 'Display localization map per device'},
      blocLabelMovingAverage: {FR: "Moyenne mobile de consommation", EN: 'Consumption moving average'},
      textConfigMovingAverage: {FR: "Options d'affichage des barres de moyenne mobile de puissance de l'onglet Mesures.", EN: 'Moving average display options in the measurement tab.'},
      buttonLabelDisplayMA: {FR: "Affichage des barres de moyenne mobile dans les entêtes des appareils en mode détails", EN: 'Display moving average bars on top of device display detail tab'},
      buttonLabelMA_DisplayActual: {FR: "Afficher la dernière mesure", EN: 'Display last reading'},
      buttonLabelMA_DisplayHr: {FR: "Afficher la moyenne mobile", EN: 'Display moving average'},
      buttonLabelMA_Day: {FR: "jour", EN: 'day'},
      buttonLabelMA_Days: {FR: "jours", EN: 'days'},

      messagePostFail:{FR: "Une erreur est survenue pendant l'opération.", EN: 'An error occurs during the operation'},
      messageRemoveConfirmA:{FR: "Confirmer la supression du système : ", EN: 'Confirm deletion of system : '},
      messageRemoveConfirmB:{FR: "Confirmer en écrivant : DELETE", EN: 'Confirm by writing : DELETE'},
      messageConfigTagDeletion:{FR: "Confirmer la supression de l'attribut (ceci met à jour les appareils et sous-system configuré avec cet élément)?", EN: 'Confirm attribute supression (this will update all device and sub-system settled with this element)?'},
      messageConfigTagCategoryDeletion:{FR: "Confirmer la supression de la catégorie (ceci retire la catégorie de tous les appareils et sous-system)?", EN: 'Confirm category supression (this will remove this categogy of all device and sub-system)?'},
      messageAddTagCategory:{FR: "Titre de la catégorie", EN: 'Category title'},
      messageAddTagCategoryTextField:{FR: "Categorie", EN: 'Category'},
      messageAddTag:{FR: "Étiquette à ajouter", EN: 'Tag to add'},
      messageAddTextField:{FR: "Étiquette", EN: 'Tag'},
      messageAddSystem:{FR: "Nouveau nom de Système : ", EN: 'New System name'},
      messageAddSystemTextField:{FR: "Nom du système", EN: 'System name'},
      messageAddNewSystem:{FR: "Nom du nouveau Système : ", EN: 'New System name'},
      messageAddNewSystemTextField:{FR: "Nom du système", EN: 'System name'},
      messageAddNewSystemToGroup:{FR: "Nom de votre nouveau Système à ajouter au Groupe : ", EN: 'New System name to add to the Group :'},


    }
  },
  components: {
    Spinner,
    ConfigSharingList
  },
  computed: {
    ...mapState('sessionStore', ['profileData','displayAdminFlag','actualGroup','actualBundle','navIndex','parentContainer']),
    ...mapState('overlayStore', ['overlayParameters']),
  },

  watch: {
    actualBundle(){
        this.reloadTempoBundle()
    },

    },  
  methods: {
    ...mapActions('overlayStore', ['showModal']),

    reloadTempoBundle(){
        //console.log('----TEMPO BUNDLE RELOADED-----')
        this.tempoBundle = JSON.parse(JSON.stringify(this.actualBundle))
    },


   toggleDisplaySharing(){
      this.flagDisplaySharing = ~this.flagDisplaySharing
    },

    toggleDisplaySubBundle(){
      this.flagDisplaySubBundle = ~this.flagDisplaySubBundle
    },

   toggleDisplayPieChart(){
      this.flagDisplayPieChart = ~this.flagDisplayPieChart
    },
   toggleDisplayAttributes(){
      this.flagDisplayAttributes = ~this.flagDisplayAttributes
    },
   toggleDisplayChannelAverage(){
      this.flagDisplayChannelAverage = ~this.flagDisplayChannelAverage
    },


    addAttributeCategorie(){
      var CategoryName = prompt(this.messageAddTagCategory[this.actualLanguage], this.messageAddTagCategoryTextField[this.actualLanguage])
      this.actualBundle.channelsAttributes.push({'title':CategoryName, 'data':[]})
      this.saveNewAttributes()
    },

    addAttributeElement(index){
      var attribute = prompt(this.messageAddTag[this.actualLanguage], this.messageAddTextField[this.actualLanguage])
      this.actualBundle.channelsAttributes[index].data.push(attribute)
      this.actualBundle.channelsAttributes[index].data.sort()
      this.saveNewAttributes()
    },

    deleteAttributeElement(index1){
          var FlagProcessToDelete = false
          FlagProcessToDelete = window.confirm(this.messageConfigTagDeletion[this.actualLanguage])

          if(FlagProcessToDelete==true){
            var AttributeToDelete = this.actualBundle.channelsAttributes[index1].data[this.channelAttributeSelect[index1]]
            //console.log(AttributeToDelete)
            this.actualBundle.channelsAttributes[index1].data.splice(this.channelAttributeSelect[index1],1)
            for(var n=0;n<this.actualBundle.channels.length;n++){
                if(this.actualBundle.channels[n].Attributes[index1]==AttributeToDelete){this.actualBundle.channels[n].Attributes[index1]='ND'}
                }
            this.saveNewAttributes()
          }
    },


    deleteCategoryList(index1){
          var FlagProcessToDelete = false
          FlagProcessToDelete = window.confirm(this.messageConfigTagCategoryDeletion[this.actualLanguage])

          if(FlagProcessToDelete==true){
            this.actualBundle.channelsAttributes.splice(index1,1)
            
            //Décallage vers la gauche des Attributs des canaux
            //console.log('------Channel Update------')
            for(var n=0;n<this.actualBundle.channels.length;n++){
                  for(var m=index1;m<this.actualBundle.channels[n].Attributes.length-1;m++){
                    this.actualBundle.channels[n].attributes[m] = this.actualBundle.channels[n].Attributes[m+1]
                    this.actualBundle.channels[n].attributes[m+1] = 'ND'
                  }
                }
            this.saveNewAttributes()

            //On doit laisser le temps à la BD de s'aupdater !
            //setTimeout(() => { this.$store.dispatch('sessionStore/getGroupArborescence'); }, 4000);
            
          }
    },


    saveChannelModifications(index) {
        this.channelIsSaving = true
        var requestData = { 'postAction':'SaveChannelModification',
                            'bundleId': this.actualBundle.bundle_id,
                            'channelIndex': index,
                            'channelData':this.actualBundle.channels[index],
                            }
                            //console.log(requestData)
        this.$store.dispatch('sessionStore/postChannel', requestData)
            .then((response) => {
              //console.log(response.data)
              //this.channelIsSaving = false
            if(response.data.Code=='OK'){
                //this.alertShowAddButton=true
                //console.log('OK')
                }
                else{ window.alert(this.messagePostFail[this.actualLanguage] )}
            })       
    },


    saveNewBundleData(){
        //On ne peut pas mettre tempoBundle directement, il a des éléments
        //vides et une erreur de post subvient
        var requestData = {'postAction':'SaveNewBundleName',
                          'bundleData':{'bundleId':this.tempoBundle.bundle_id,
                                        'bundleName':this.tempoBundle.bundle_name}}

        //console.log(requestData)
        this.$store.dispatch('sessionStore/postBundle', requestData)
            .then((response) => {
            if(response.data.Code=='OK'){
                //this.$store.dispatch('sessionStore/getGroupArborescence')
                this.$store.dispatch('sessionStore/reloadActualBundle')
                }
            })
    },


    saveNewAttributes(){
        //On ne peut pas mettre tempoBundle directement, il a des éléments
        //vides et une erreur de post subvient
        var requestData = {'postAction':'SaveBundleAttributes',
                          'bundleData':{'bundleId':this.tempoBundle.bundle_id,
                                        'channelsAttributes':this.actualBundle.channelsAttributes,
                                        'bundleChannelsList':this.actualBundle.channels}}

        //console.log(requestData)
        this.$store.dispatch('sessionStore/postBundle', requestData)
            .then((response) => {
            if(response.data.Code=='OK'){
                //console.log('Channel Attributes updated')
                }else{ 
                  window.alert(this.messagePostFail[this.actualLanguage] )
                  //console.log(response.data)
                  }
            })
    },


    saveNewBundleConfiguration(){
        //On ne peut pas mettre tempoBundle directement, il a des éléments
        //vides et une erreur de post subvient
        var requestData = {'postAction':'saveNewBundleConfiguration',
                          'bundleData':{'bundleId':this.tempoBundle.bundle_id,
                                        'bundleConfiguration':this.actualBundle.bundle_configuration}}

        //console.log(requestData)
        this.$store.dispatch('sessionStore/postBundle', requestData)
            .then((response) => {
            if(response.data.Code=='OK'){
                //console.log('Channel MA options updated')
                }else{ 
                  window.alert(this.messagePostFail[this.actualLanguage]  )
                  //console.log(response.data)
                  }
            })
    },


    saveNewBundleName(){
        var newBundleName = prompt(this.messageAddSystem[this.actualLanguage], this.messageAddSystemTextField[this.actualLanguage]);

        if(newBundleName != null){
            this.newBundleIsSaving = true
            var requestData = {'postAction':'SaveNewBundleName',
                  'bundleData':{'bundleId':this.tempoBundle.bundle_id,
                                'bundleName':newBundleName}}
            this.$store.dispatch('sessionStore/postBundle', requestData)
                .then((response) => {
                if(response.data.Code=='OK'){
                    this.newBundleIsSaving = false
                    this.$store.dispatch('sessionStore/getGroupArborescence')
                    }
                })
            }    
    },


    saveNewSubBundle() {
        var newBundleName = prompt(this.messageAddNewSystem[this.actualLanguage], this.messageAddNewSystemTextField[this.actualLanguage]);

        if(newBundleName != null){
            this.addBundleIsSaving = true
            var requestData = {'postAction':'AddNewSubBundle',
                  'bundleData':{'bundleId':this.tempoBundle.bundle_id,
                                'bundleName':newBundleName}}
            this.$store.dispatch('sessionStore/postBundle', requestData)
                .then((response) => {
                  //console.log(response.data)
                if(response.data.Code=='OK'){
                    this.addBundleIsSaving = false
                    this.$store.dispatch('sessionStore/getGroupArborescence')
                    }else{ window.alert(this.messagePostFail[this.actualLanguage] )}
                })
            }    
    },  



    createNewBundleInGroup(){
        var newBundleName = prompt(this.messageAddNewSystemToGroup[this.actualLanguage]+this.actualGroup.group_name, this.messageAddNewSystemTextField[this.actualLanguage])

        if(newBundleName != null){
            this.newBundleIsSaving2 = true
            var requestData = {'postAction':'CreateNewBundleInGroup',
                                'bundleName':newBundleName,
                                'hostGroup':this.actualGroup.group_id}
            this.$store.dispatch('sessionStore/postGroup', requestData)
                .then((response) => {
                this.newBundleIsSaving2 = false
                if(response.data.Code=='OK'){
                    this.$store.dispatch('sessionStore/getGroupArborescence')
                    }else{ window.alert(this.messagePostFail[this.actualLanguage] )}
                })
            }    
    },


    deleteBundle(){
      //console.log(this.navIndex)
        var confirmation = prompt(this.messageRemoveConfirmA[this.actualLanguage]+this.actualBundle.bundle_name, this.messageRemoveConfirmB[this.actualLanguage]);

        if(confirmation == 'DELETE'){
            this.bundleIsDeleting = true
            var hostId = this.navIndex.bundleParentId

            var requestData = {'postAction':'DeleteBundle',
                                'bundleId':this.actualBundle.bundle_id,
                                'parentContainer':this.parentContainer}
            this.$store.dispatch('sessionStore/postBundle', requestData)
                .then((response) => {
                if(response.data.Code=='OK'){
                    //this.$store.dispatch('sessionStore/getGroupArborescence')
                    document.location.reload()
                    this.bundleIsDeleting = false
                    }else{ window.alert(this.messagePostFail[this.actualLanguage] )}
                })
            }    
    },




    shareEntity(){
      var modalParameters = {'modalTitle':{FR: "Partage de Système", EN: 'System sharing'},
                        'entityOwner':this.actualBundle.bundle_id,
                        'sharingType':'Bundle',
                        'entityId':this.actualBundle.bundle_id,
                        'entityReferenceName':this.actualBundle.bundle_name,
                        'displayAlertOptions':false,
                        'displayChannelOptions':true,
                        'displayDeviceOptions':true,
                        'displayBundleOptions':true,
                        'displayGroupOptions':false,
                        'displayUserOptions':false}

      this.$store.dispatch('overlayStore/setParameters',modalParameters)
      this.showModal('config-access-rules-form')
    },



    findPermissionItemValue(permissionList,idToFind){
        var value = false
        for (var n = 0; n < permissionList.length; n++){
          if(permissionList[n].id == idToFind)
          {value = permissionList[n].value}
        }
        return value
    },    




  },
  mounted() {

    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}
    this.reloadTempoBundle()

    //Pour comparer le parentContainer on retire les premiers caractèeres qui contiennent le préfixe de navigation
    this.actualParentIsOwner = this.actualBundle.bundle_id.includes(this.parentContainer.slice(6))
    this.actualBundleIsDefaultBundle = this.actualBundle.bundle_id.includes('DefaultGroup::DefaultBundle')
    this.flagDisplayDeleteBundle = this.actualParentIsOwner && (this.actualBundleIsDefaultBundle==false)


    this.bundleConfigViewFlag = this.findPermissionItemValue(this.actualBundle.permissions.bundle,'bundleConfigView')
    this.bundleConfigEditFlag = this.findPermissionItemValue(this.actualBundle.permissions.bundle,'bundleConfigEdit')
    this.bundleConfigDeleteFlag = this.findPermissionItemValue(this.actualBundle.permissions.bundle,'bundleConfigDelete')
    this.bundleSharingEnableFlag = this.findPermissionItemValue(this.actualBundle.permissions.bundle,'bundleSharingEnable')

    this.flagDisplayCompleteBundleName = this.profileData.profileInfo.profile_type['masterUserCode'].includes("-EVSensAdmin")

    window.scrollTo(0, 0)
  }
}
</script>

<style lang="css">
  .h2 {font-size: 24px;}
  .h2 {font-size: 20px;}
  .h3 {font-size: 16px;}
  .h4 {font-size: 14px;}
  .h5 {font-size: 12px;}

  /* Media Query pour les écrans de moins de 600px de large */
  @media (max-width: 600px) {
      .h2 {font-size: 18px;}
      .h2 {font-size: 16px;}
      .h3 {font-size: 14px;}
      .h4 {font-size: 10px;}
      .h5 {font-size: 8px;}
  }

</style>



// WEBPACK FOOTER //
// ConfigBundle.vue?c4c94310